import LoadingButton from "@mui/lab/LoadingButton";
import {
  Box,
  Grid,
  Typography
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { ReportAxisValue } from "../../models/reporting/reportAxisValue";
import { ReportEntity } from "../../models/reporting/reportEntity";
import { ReportPeriod } from "../../models/reporting/reportPeriod";
import { ReportType } from "../../models/reporting/reportType";
import { ReportVisualScale } from "../../models/reporting/reportVisualScale";
import { ReportDetailsForm } from "./ReportDetailsForm";
import { useCreateReport } from "../../hooks/reporting/useCreateReport";

type EditReportProps = {
  handleClose: () => void;
};

export const CreateReport = ({ handleClose }: EditReportProps) => {
  const [error, setError] = useState("");


  const createReport = useCreateReport({
    onSuccess: () => {
      handleClose();
    },
    onError: (error: Error) => {
      setError(error.message);
    }
  });
  
  const { resetForm, ...formik } = useFormik({
    initialValues: {
      title: "",
      type: ReportType.LINE_CHART,
      entity: ReportEntity.EMPLOYEES,
      visualScale: ReportVisualScale.LG,
      data: {
        xAxis: ReportAxisValue.TIME,
        yAxis: ReportAxisValue.COUNT,
        period: ReportPeriod.ALL_TIME,
        isAnonymised: true
      },
      filters: []
    },
    onSubmit: async (values) => {
      createReport.mutate(values);
    },
    enableReinitialize: true
  });

  // Reset form when the modal is opened
  useEffect(() => {
    resetForm();
    setError("");
  }, [resetForm, setError]);

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Box padding={2}>
          <Grid container spacing={2}>
            {error && (
              <Grid item xs={12}>
                <Typography color="error">{error}</Typography>
              </Grid>
            )}
            <Box sx={{ width: "100%", px: 2, pt: 2 }}>
              <ReportDetailsForm form={formik} />
            </Box>
          </Grid>
        </Box>
        <Box padding={2}>
          <LoadingButton
            type="submit"
            variant="contained"
            fullWidth
            color="primary"
            loading={createReport.isLoading}
          >
            Save
          </LoadingButton>
        </Box>
      </form>
    </>
  );
};
